import i18n from "@/plugins/i18n";
import { XmlElementWrapper } from "./xml-element-wrapper";

export class XmlDocumentWrapper
{
    protected doc: XMLDocument;

    public constructor(doc: XMLDocument)
    {
        this.doc = doc;
    }

    public static instance(): XmlDocumentWrapper
    {
        return new this(document.implementation.createDocument(null, null, null));
    }

    public createElement(tagName: string, options?: ElementCreationOptions|undefined): XmlElementWrapper
    {
        return new XmlElementWrapper(
            this.doc.createElement(tagName, options),
            i18n.global.locale.value,
            "" //i18n.global.fallbackLocale.value
        );
    }
}
